import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Tab = ({
  children,
  className,
  disabled,
  isSelected,
  onClick,
  tabIndex,
  ...rest
}) => {
  const classes = cn('c-tab', className, {
    'is-disabled': disabled,
    'is-selected': isSelected,
  });

  return (
    <li className="c-tabs__item" role="presentation">
      <button
        aria-selected={!!isSelected}
        tabIndex={tabIndex || (isSelected ? 0 : -1)}
        className={classes}
        disabled={disabled}
        onClick={onClick}
        role="tab"
        type="button"
        {...rest}
      >
        <span>{children}</span>
      </button>
    </li>
  );
};

export default Tab;

Tab.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Tab.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  isSelected: false,
  tabIndex: '',
};
